import {type AxiosResponse} from "axios";
import {accountEndpoint} from "./endpoints";
import {get} from "../../infrastructure/api";
import {type AccountDto} from "./types";
import {type ApiResponse} from "../../infrastructure/types";

export const getAccount = async (): Promise<AxiosResponse<ApiResponse<AccountDto>>> =>
  await get({endpoint: accountEndpoint});
